import React from "react";
import {
  Route,
  Switch,
  withRouter,
} from "react-router-dom";
import { withStyles } from '@material-ui/styles';

import LandingPage from "../../pages/landingPage/landingPage";
import MainLogin from "../../pages/landingPage/MainLogin";
import AccountPage from "../../pages/landingPage/AccountPage";
import VerifyEmail from "../../pages/landingPage/VerifyEmail";
import Privacy from "../../pages/landingPage/Privacy";
import Exam from "../../pages/landingPage/Exam";

const makeStyles = theme => ({
  root: {
    display: "flex",
    maxWidth: "100vw",
    overflowX: "hidden",
  }
});

class MainLayout extends React.Component {

  constructor(props){
    super(props)
    this.state = { }
  }

  async componentDidMount(){

  }


  render (){

    // global
    const { classes } = this.props;

    return (
      <div className={classes.root}>
          <>
              <Switch>
                <Route path='/main/home' component={LandingPage} />
                <Route path='/main/login' component={MainLogin} />
                <Route path='/main/account' component={AccountPage} />
                <Route path='/main/verify' component={VerifyEmail} />
                <Route path='/main/exam' component={Exam} />
                <Route path='/main/privacy' component={Privacy} />
              </Switch>
          </>
      </div>
    );
  }
  
}

export default withStyles(makeStyles)(withRouter(MainLayout));
